import hcOffcanvasNav from "hc-offcanvas-nav";

/**
 * More configurations can be found at https://github.com/somewebmedia/hc-offcanvas-nav
 */
export default function mobileMenu(menuContainerCssClass: string, toggleBtnCssClass: string) {
	new hcOffcanvasNav(menuContainerCssClass, {
		disableAt: 1280,
		customToggle: toggleBtnCssClass,
		position: 'left',
    bodyInsert: 'append',
    ariaLabels: {
      open: 'Ouvrir le menu',
      close: 'Fermer le menu',
      submenu: 'Sous-menu'
    },
    labelBack: 'Retour'
  });
}